import { useContext } from "react";
import Scrollbar from "src/components/Scrollbar";
import { SidebarContext } from "src/contexts/SidebarContext";

import { Box, Drawer, alpha, styled, Divider, useTheme, lighten, darken, IconButton, Tooltip } from "@mui/material";
import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";

import SidebarMenu from "./SidebarMenu";
import SidebarFooter from "./SidebarFooter";
import Logo from "src/components/LogoSign";
import PortalPromo from "src/components/PortalPromo";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
`
);

const PROMO_WIDTH = '440px';

function Sidebar() {
  const { sidebarToggle, toggleSidebar, sidebarCollapsed, toggleCollapse } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const isLoggedIn = !!localStorage.getItem("accessToken");

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: "none",
            lg: "inline-block",
          },
          position: "fixed",
          left: 0,
          top: 0,
          width: sidebarCollapsed ? '0 !important' : isLoggedIn ? undefined : `${PROMO_WIDTH} !important`,
          minWidth: sidebarCollapsed ? '0 !important' : isLoggedIn ? undefined : `${PROMO_WIDTH} !important`,
          overflow: 'hidden',
          transition: 'width 0.2s ease, min-width 0.2s ease',
          background:
            theme.palette.mode === "dark"
              ? theme.sidebar.background
              : darken(theme.colors.alpha.black[100], 0.5),
          boxShadow: theme.palette.mode === "dark" ? theme.sidebar.boxShadow : "none",
        }}
      >
        <Scrollbar>
          {isLoggedIn ? (
            <>
              <Box
                sx={{
                  height: theme.header.height,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2,
                }}
              >
                <Logo />
                <Tooltip arrow title="Fechar menu" placement="right">
                  <IconButton onClick={toggleCollapse} sx={{ color: "primary.main" }}>
                    <ChevronLeftTwoToneIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Divider sx={{ mb: theme.spacing(3), mx: theme.spacing(2), background: theme.colors.alpha.trueWhite[10] }} />
              <SidebarMenu />
            </>
          ) : (
            <Box sx={{ p: '48px' }}>
              <PortalPromo dark logoWidth={250} showLogo />
            </Box>
          )}
        </Scrollbar>
        <SidebarFooter />
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`,
        }}
        anchor={theme.direction === "rtl" ? "right" : "left"}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === "dark"
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5),
          }}
        >
          <Scrollbar>
            <Box
              sx={{
                height: theme.header.height,
                display: "flex",
                alignItems: "center",
                px: 2,
              }}
            >
              <Logo />
            </Box>
            <Divider
              sx={{
                mb: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.trueWhite[10],
              }}
            />
            <SidebarMenu />
          </Scrollbar>
          <SidebarFooter />
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
